import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Card } from "primereact/card";
import { Modal, Form, Col, Row, Button as ReactButton } from 'react-bootstrap';
import { handleRequest } from '../../redux/config/env';
import { Form as FormAnt } from 'antd';
import { FormattedMessage } from "react-intl";
import 'react-contexify/dist/ReactContexify.min.css';
import { Item, MenuProvider } from 'react-contexify';
import CustomMaterialMenu from '../settings/ForComponents/CustomMaterialMenu';
import HowtoUse from '../standardization/HowtoUse';
import Settings from '../standardization/Settings';
import Whatis from '../standardization/Whatis';
import { Table, Input, Select, InputNumber, Checkbox, Radio, Divider, DatePicker, Switch, Button as AntButton, Cascader } from 'antd';
import { Avatar } from 'antd';
import moment from 'moment'
import { PlusOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { API_BASE } from '../../redux/config/env';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { DownloadOutlined } from '@ant-design/icons';
import { setStandardization, getDynamicMenu, getUserSettings } from '../../redux/config/imu.js';

const { RangePicker } = DatePicker;
const { Column } = Table;
const { Option } = Select;

const itemTypeSelectItems = [{ id: 1, value: "Material" }, { id: 2, value: "Equipment" }];
var t = "import { DownloadOutlined } from '@ant-design/icons';";
const pageName = "ItemDimension";

export class ItemDimension extends Component {

    constructor() {
        super();
        console.log(t);
        this.state = {
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,

            modalPhotoShow: false,
            imageUrl: null,

            itemGroupSelectItems: [],
            itemList: [],
            itemId: 0,
            itemType: null,
            groupId: null,
            itemName: '',
            sketchPath: '',

            filePath: '',
            fileList: [],
            dimensionList: [],
            oldDimensions: [],
            description: '',
            abbreviation: '',
            unitTypeId: null,

            itemGroupIds: [],
            itemGroups: [],
            nodes: [],
            allNodes: [],
            hideGroupModal: true,
            groupName: '',
            unitTypeSelectItems:[],

            columns: [
                {
                    key: "key",
                    title: "Action",
                    render: (value, row, index) => {

                        return this.actionTemplate(row);

                    }
                },
                {
                    key: "key",
                    title: "Item Description",
                    dataIndex: "itemName"
                },
                {
                    key: "key",
                    title: "Shape",
                    align: "center",
                    render: (value, row, index) => {

                        if (Boolean(row.sketchPath))

                            return <div
                                style={{
                                    cursor: "pointer"
                                }}
                                onClick={() =>
                                    this.setState({
                                        imageUrl: row.sketchPath,
                                        modalPhotoShow: true,
                                    })
                                }
                            >
                                <Avatar shape="square" size={100} src={row.sketchPath} />

                            </div>;

                        else return "";

                    }
                }

            ],


            authorizations: [],
            dynamicInputs: [],
            isAdmin: false,
            howToUseSetting: false,
            whatIsSetting: false,
            dynamicAttributes: [],

            formId: 0
        };
        // this.actionTemplate = this.actionTemplate.bind(this);
        // this.showSuccess = this.showSuccess.bind(this);
        // this.showError = this.showError.bind(this);
        // this.showWarning = this.showWarning.bind(this);

    }

    formRef = React.createRef();


    componentDidMount = async () => {


        var isAdmin = false;
        let dynamicMenu = await getDynamicMenu(pageName);
        this.getUserSettings(dynamicMenu.formId);
        if (Boolean(this.props.auth) && Boolean(this.props.auth.user) && this.props.auth.user.userType === 2) {
            isAdmin = true;
        }

        let standardization = await setStandardization(pageName);
        this.setState({
            dynamicAttributes: standardization.dynamicAttributes,
            dynamicInputs: standardization.dynamicInputs,
            isAdmin: isAdmin,
            formId: dynamicMenu.formId,
            authorizations: dynamicMenu.authorizations
        })

        this.restartTable();
        this.fillNodes();
        this.getDimensionList();
        this.setComboboxes();


    }

    getUserSettings = async (formId) => {

        let userSettings = await getUserSettings(formId);
        this.setState(
            {
                howToUseSetting: userSettings.howToUseSetting,
                whatIsSetting: userSettings.whatIsSetting
            }
        )
    }

    save = async () => {

        var _itemDimensions = Boolean(this.state.oldDimensions) ? this.state.oldDimensions : [];

        if (Boolean(_itemDimensions) && _itemDimensions.length > 0) {
            _itemDimensions.forEach(element => {
                element.active = false;
            });
        }

        if (Boolean(this.state.dimensionList)) {
            var filteredList = this.state.dimensionList.filter(p => p.select === true);
            filteredList.forEach(element => {
                let index = -1;
                if (_itemDimensions.length > 0)
                    index = _itemDimensions.findIndex(p => p.dimensionId === element.id);
                if (index >= 0) {
                    _itemDimensions[index].active = true;
                }
                else {
                    let obj = { dimensionId: element.id, active: true };
                    _itemDimensions.push(obj);
                }

            });
        }
        var groupId = null;
        if (Boolean(this.state.itemGroupIds) && this.state.itemGroupIds.length > 0) {
            groupId = this.state.itemGroupIds[this.state.itemGroupIds.length - 1];
        }
        const obj = {
            id: this.state.itemId,
            itemType: this.state.itemType,
            groupId: groupId,
            itemName: this.state.itemName,
            sketchPath: this.state.filePath,
            itemDimensions: _itemDimensions
        }

        console.log(obj);
        if (obj.id === 0)
            await handleRequest("POST", "/ItemMaterialEquipment/add", obj);
        else
            await handleRequest("POST", "/ItemMaterialEquipment/update", obj);

        this.showSuccess();
        this.resetInputs();
        this.restartTable();

    }

    edit = (row) => {

        var dimensionList = this.state.dimensionList;

        if (Boolean(row.itemDimensions) && Boolean(dimensionList) && dimensionList.length > 0 && row.itemDimensions.length > 0) {
            row.itemDimensions.forEach(element => {

                let index = dimensionList.findIndex(p => p.id === element.dimensionId);
                if (index >= 0) {
                    dimensionList[index].select = true;
                }

            });
        }

        let fileList = [{
            uid: '1',
            name: row.itemName + '.png',
            status: 'done',
            url: row.sketchPath,
        }]

        let ids = [];
        if (Boolean(row.itemGroup)) {

            if (Boolean(row.itemGroup.hierarchyCode) && row.itemGroup.hierarchyCode.length > 0) {
                if (row.itemGroup.hierarchyCode.includes(","))
                    ids = row.itemGroup.hierarchyCode.split(",");
                else ids.push(row.itemGroup.hierarchyCode);
            }
            ids.push(row.groupId.toString());
        }

        console.log(ids);

        this.setState({
            itemId: row.id,
            itemType: row.itemType,
            groupId: row.groupId,
            itemGroupIds: ids,
            itemName: row.itemName,
            sketchPath: row.sketchPath,
            filePath: row.sketchPath,
            fileList: fileList,
            oldDimensions: row.itemDimensions,
            dimensionList: dimensionList,
            hideSave: true,
            hideUpdate: false,
            hideInputs: false,

        });

    }


    delete = async () => {
        const obj = {
            id: this.state.itemId
        }

        await handleRequest("POST", "/ItemMaterialEquipment/delete", obj);

        this.restartTable();
        this.showSuccess();
        this.showOrHideDeleteModal();
    }

    deleteModal = (row) => {
        this.setState({
            modalDeleteShow: true,
            itemId: row.id
        });
    }

    showOrHideDeleteModal = () => {
        this.setState({
            modalDeleteShow: !this.state.modalDeleteShow
        });

        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }



    showSuccess(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageSuccess1" defaultMessage="Successfull" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Success"
        });
    }

    showError(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageError1" defaultMessage="An error was occured please try again later !" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Error"
        });
    }

    showWarning(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageCheckInputs" defaultMessage="Something went wrong. Please check inputs." />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Warning"
        });
    };




    actionTemplate(rowData, column) {


        return <React.Fragment>
            <CustomMaterialMenu row={rowData} onDeleteRow={this.deleteModal.bind(this)} onEditRow={this.edit.bind(this)} />
        </React.Fragment>;


    }


    restartTable = async () => {
        const response = await handleRequest("GET", "/ItemMaterialEquipment/getAllByCompany");

        if (response.data.length !== 0) {
            const list = response.data;
            list.forEach(element => {
                element.key = element.id


                if (Boolean(element.itemDimensions) && element.itemDimensions.length > 0) {
                    element.itemDimensions.forEach(dimension => {
                        element[dimension.dimensionId + ""] = <CheckOutlined style={{ fontSize: '24px', color: '#08c' }} ></CheckOutlined>;
                    });
                }
            });
            console.log(list);
            this.setState({
                itemList: list,
            });
        }

        if (response.data.length === 0) {
            this.setState({
                itemList: [],
            });
        }
    }









    createNew = () => {

        this.setState({
            hideInputs: !this.state.hideInputs,
            itemType: null,
            groupId: null,
            itemName: '',
            sketchPath: '',
            fileList: [],
            filePath: '',
            oldDimensions: [],
            itemId: 0,
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,
        });
        this.getDimensionList();
    }


    stop = () => {

        this.setState({
            itemType: null,
            groupId: null,
            itemName: '',
            sketchPath: '',
            fileList: [],
            filePath: '',
            oldDimensions: [],
            itemId: 0,
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,
        });
        this.getDimensionList();
    }



    resetInputs = () => {
        this.setState({
            itemType: null,
            groupId: null,
            itemName: '',
            sketchPath: '',
            fileList: [],
            filePath: '',
            oldDimensions: [],
            itemId: 0,
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,
        });
        this.getDimensionList();
    }


    cancel = () => {

        this.resetInputs();
    }





    searchTree = (element, matchingTitle) => {
        if (element.data.page == matchingTitle) {
            return element;
        } else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchTree(element.children[i], matchingTitle);
            }
            return result;
        }
        return null;
    }



    showOrHideModalMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
        }, 500);
    }

    addItemGroup = async () => {
        const { codeName } = this.state;

        if (Boolean(this.state.itemType)) {

            const newItem = {
                itemType: this.state.itemType,
                groupName: codeName
            }

            await handleRequest("POST", "/ItemGroup/add", newItem);


            this.setState({

                codeName: '',
            });

            this.fillCodes();
        }
        else this.showError("Please select the item type!")

    };

    addItemGroup2 = async () => {
        const { groupName } = this.state;

        if (Boolean(this.state.itemType)) {

            const newItem = {
                itemType: this.state.itemType,
                groupName: groupName,
                hierarchyCode: Boolean(this.state.itemGroupIds) ? this.state.itemGroupIds.toString() : null,
                parentId: Boolean(this.state.itemGroupIds) && this.state.itemGroupIds.length > 0 ? this.state.itemGroupIds[this.state.itemGroupIds.length - 1] : null
            }

            await handleRequest("POST", "/ItemGroup/add", newItem);


            this.setState({

                groupName: '',
                hideGroupModal: true,
            });

            this.fillNodes();
            this.showSuccess();
        }
        else this.showError("Please select the item type!")

    };



    fillCodes = async () => {

        const response = await handleRequest("GET", "/ItemGroup/type/" + this.state.itemType);
        console.log("geldi fillCodes")
        if (response.data !== null && response.data !== undefined) {
            this.setState({
                itemGroupSelectItems: response.data
            });
        }
    }

    fillNodes = async () => {
        const response3 = await handleRequest("GET", "/ItemGroup/getNodes");

        if (response3.data.length === 0) {
            this.setState({
                nodes: [],
                allNodes: [],
            });
        } else if (response3.data.length !== 0) {
            this.setState({
                nodes: response3.data,
                allNodes: response3.data
            });
        }

    }

    refreshNodes = () => {

        var list = this.state.allNodes;

        if (Boolean(list) && list.length > 0 && Boolean(this.state.itemType)) {
            list = list.filter(p => p.itemType === this.state.itemType)
        }

        this.setState({
            nodes: list
        })

    }

    addDimension = async () => {
        if (this.state.description.length > 0 && Boolean(this.state.unitTypeId)) {
            const obj = {

                description: this.state.description,
                abbreviation: this.state.abbreviation,
                unitTypeId: this.state.unitTypeId,
            }

            console.log(obj);

            await handleRequest("POST", "/Dimension/add", obj);

            // await handleRequest("POST", "/Dimension/update", obj);

            this.showSuccess();

            this.setState({
                description: '',
                abbreviation: '',
                unitTypeId: null,
            })

            this.getDimensionList();
        }
        else this.showError("Please type dimension inputs for adding new dimension.")

    }


    getDimensionList = async () => {

        const response = await handleRequest("GET", "/Dimension/getAllByCompany");

        if (response.data !== null && response.data !== undefined) {
            const list = response.data;
            const columns = this.state.columns;
            list.forEach(element => {
                element.select = false;
                if (Boolean(columns) && !Boolean(columns.find(p => p.key === element.id))) {
                    let col = {
                        key: element.id,
                        title: element.description,
                        align: "center",
                        dataIndex: element.id + ''
                    }
                    columns.push(col);
                }
            });

            this.setState({
                dimensionList: list,
                columns: columns
            });
        }
    }

    setComboboxes = async () => {

        const response = await handleRequest("GET", "/UnitType/getallByCompany");

        if (response.data !== null && response.data !== undefined) {
            this.setState({
                unitTypeSelectItems: response.data
            });
        }
    }

    onChangeItemGroup = (value, data) => {
        this.setState({
            itemGroupIds: value,
            itemGroups: data,
        });
    };



    render() {

        const props = {
            action: `${API_BASE}/File/upload`,
            listType: 'picture',
            defaultFileList: [...this.state.fileList],
        };

        const onFinish = values => {
            console.log('Success:', values);
        };

        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
        };

        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };


        return (this.state.formId > 0) ? (
            (this.state.authorizations.length > 0 && this.state.authorizations.findIndex(p => p.action === "view") >= 0)
                ? (
                    <div>

                        <MenuProvider id="menu_id">


                            <Modal
                                show={this.state.modalDeleteShow}
                                onHide={this.showOrHideDeleteModal}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">Chosen status will be deleted !</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Are you sure?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <ReactButton variant="secondary" onClick={this.showOrHideDeleteModal}>Cancel</ReactButton>
                                    <ReactButton variant="danger" onClick={this.delete} >Delete</ReactButton>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={!this.state.hideGroupModal}
                                onHide={() => {
                                    this.setState({
                                        hideGroupModal: true,
                                        groupName: '',

                                    })
                                }}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">Select Items</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group style={{ marginBottom: '1rem' }} as={Row}>

                                        <Col sm="12">
                                            <Input id="todo" value={this.state.groupName} onChange={(e) => this.setState({ groupName: e.target.value })} />

                                        </Col>

                                    </Form.Group>

                                </Modal.Body>
                                <Modal.Footer>
                                    <ReactButton variant="secondary" onClick={() => {
                                        this.setState({
                                            hideGroupModal: true,
                                            groupName: '',
                                        })
                                    }}>Cancel</ReactButton>
                                    <ReactButton variant="info" onClick={this.addItemGroup2} >Add</ReactButton>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={this.state.modalPhotoShow}
                                onHide={() => {
                                    this.setState({
                                        modalPhotoShow: false
                                    })
                                }}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">Photo</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {Boolean(this.state.imageUrl) && this.state.imageUrl !== "" ? (
                                        <img
                                            src={this.state.imageUrl}
                                            alt="avatar"
                                            style={{ width: "100%" }}
                                        />
                                    ) : (
                                            <p>Photo has not been uploaded.</p>
                                        )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <ReactButton variant="info" onClick={() => {
                                        this.setState({
                                            modalPhotoShow: false
                                        })
                                    }} >
                                        Close
                            </ReactButton>
                                </Modal.Footer>
                            </Modal>

                            <Card>

                                <div>
                                    <Row>
                                        <Col sm="1">
                                            <Settings formId={this.state.formId} onSaveChanges={this.getUserSettings.bind(this)} ></Settings>

                                        </Col>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="1" style={{ textAlign: "right" }}>
                                            {!this.state.howToUseSetting && <HowtoUse formId={this.state.formId} ></HowtoUse>

                                            }
                                        </Col>
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="2">
                                            {/*<Button style={{ width: '100%' }} id='create-new' icon="pi pi-plus" onClick={this.createNew} label="Create New" />*/}
                                            {this.state.hideInputs &&
                                                <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="primary" onClick={this.createNew}><FormattedMessage id="GeneralButtonCreateNew" defaultMessage="Create New" /></ReactButton>
                                            }

                                            {!this.state.hideInputs &&
                                                <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="danger" onClick={this.stop}><FormattedMessage id="GeneralButtonStopProcess" defaultMessage="Stop the process" /></ReactButton>
                                            }

                                        </Col>
                                    </Row>
                                </div>

                                <div hidden={this.state.hideInputs} style={{ marginBottom: '2rem' }}>

                                    <FormAnt
                                        {...layout}
                                        initialValues={{ remember: false }}
                                        onFinish={this.save}
                                        onFinishFailed={onFinishFailed}
                                        ref={this.formRef}
                                    >

                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Item Type" />}
                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type abbreviation" /> }]} >
                                                <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                                    <Col sm="6">
                                                        <Select placeholder="" value={this.state.itemType} onChange={(value) => {
                                                            this.setState({
                                                                itemType: value,
                                                                groupId: null

                                                            },
                                                                this.refreshNodes
                                                            )
                                                        }}
                                                        >
                                                            <Option key={null} value={null}>Select</Option>
                                                            {itemTypeSelectItems.map(i => (
                                                                <Option key={i.id} value={i.id}>{i.value}</Option>
                                                            ))}
                                                        </Select>
                                                    </Col>
                                                    <Col sm="6">
                                                    </Col>
                                                </Form.Group>
                                            </FormAnt.Item>
                                        }



                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Parent" />}
                                                name="OrganizationalLevelRoleGroup"
                                                id="OrganizationalLevelRoleGroup"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type status" /> }]} >
                                                <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                                    <Col sm="4">
                                                        <Cascader
                                                            style={{ width: "100%" }}
                                                            value={this.state.itemGroupIds}
                                                            options={this.state.nodes}
                                                            onChange={(value, data) => {
                                                                this.setState({
                                                                    itemGroupIds: value,
                                                                    itemGroups: data,
                                                                });
                                                            }}

                                                        />
                                                    </Col>
                                                    <Col sm="2">
                                                        <AntButton onClick={() => {
                                                            this.setState({
                                                                hideGroupModal: false
                                                            })
                                                        }} type="primary" style={{ width: "100%", marginTop: "0.2rem" }}>
                                                            Add New
                                         </AntButton>
                                                    </Col>
                                                </Form.Group>
                                            </FormAnt.Item>
                                        }

                                        {/* {
                                <FormAnt.Item
                                    label={<FormattedMessage id="todo" defaultMessage="Parent" />}
                                    name="OrganizationalLevelRoleGroup"
                                    id="OrganizationalLevelRoleGroup"
                                    rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type status" /> }]} >
                                    <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                        <Col sm="6">
                                            <Select
                                                style={{ width: "100%" }}
                                                placeholder="Unit"
                                                value={this.state.groupId} onChange={(value) => {
                                                    this.setState({
                                                        groupId: value
                                                    })
                                                }}

                                                dropdownRender={menu => (
                                                    <div>
                                                        {menu}
                                                        <Divider style={{ margin: '4px 0' }} />
                                                        <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                                                            <Input style={{ flex: 'auto' }} value={this.state.codeName} onChange={(event) => {
                                                                this.setState({
                                                                    codeName: event.target.value,
                                                                });
                                                            }} />
                                                            <a
                                                                style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                                                onClick={this.addItemGroup}
                                                            >
                                                                <PlusOutlined /> Add item
                                                                </a>
                                                        </div>
                                                    </div>
                                                )}

                                            >
                                                {this.state.itemGroupSelectItems.map(i => (
                                                    <Option key={i.id} value={i.id}>{i.groupName}</Option>
                                                ))}
                                            </Select>

                                        </Col>
                                        <Col sm="1">

                                        </Col>
                                    </Form.Group>
                                </FormAnt.Item>
                            } */}

                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Description" />}
                                                name="OrganizationalLevelRoleGroup"
                                                id="OrganizationalLevelRoleGroup"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type status" /> }]} >
                                                <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                                    <Col sm="6">
                                                        <Input id="todo" value={this.state.itemName} onChange={(e) => this.setState({ itemName: e.target.value })} />


                                                    </Col>
                                                    <Col sm="6">
                                                    </Col>
                                                </Form.Group>
                                            </FormAnt.Item>
                                        }

                                        {
                                            <FormAnt.Item
                                                label={<FormattedMessage id="todo" defaultMessage="Sketch" />}
                                                name="OrganizationalLevelRoleGroup"
                                                id="OrganizationalLevelRoleGroup"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type status" /> }]} >
                                                <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                                    <Col sm="6">
                                                        <Upload {...props}
                                                            showUploadList={true}
                                                            fileList={this.state.fileList}
                                                            onChange={({ fileList }) => {
                                                                if (fileList.length == 1) {
                                                                    var filePath = "";
                                                                    if (Boolean(fileList[0].response)) {
                                                                        filePath = fileList[0].response.url;
                                                                        this.showSuccess("file uploaded successfully");
                                                                        // fileName: info.file.name, 
                                                                    }
                                                                    this.setState({
                                                                        fileList: fileList,
                                                                        filePath: filePath,
                                                                    });
                                                                }
                                                            }}
                                                            beforeUpload={(fileList) => {
                                                                if (this.state.fileList.length > 0) {
                                                                    this.showError("You have been already choose a file! For change firstly remove the uploaded file.");
                                                                    return false;
                                                                }
                                                                return true;
                                                            }}
                                                            onRemove={({ fileList }) => {
                                                                this.setState({
                                                                    fileList: [],
                                                                    filePath: "",
                                                                })
                                                            }
                                                            }>
                                                            <AntButton style={{ width: "100%", marginTop: "0.2rem" }}>
                                                                <UploadOutlined /> Add Sketch
                            </AntButton>
                                                        </Upload>
                                                    </Col>
                                                    <Col sm="6">
                                                    </Col>
                                                </Form.Group>
                                            </FormAnt.Item>
                                        }

                                        {
                                            <FormAnt.Item
                                                label={""}
                                                name="OrganizationalLevelDesignation"
                                                rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please type abbreviation" /> }]} >
                                                <Form.Group style={{ marginBottom: '0rem' }} as={Row}>
                                                    <Col sm="4">
                                                    </Col>
                                                    <Col sm="2">
                                                        <Input id="todo" placeholder="Description" value={this.state.description} onChange={(e) => this.setState({ description: e.target.value })} />


                                                    </Col>
                                                    <Col sm="2">
                                                        <Input id="todo" placeholder="Abbreviation" value={this.state.abbreviation} onChange={(e) => this.setState({ abbreviation: e.target.value })} />


                                                    </Col>

                                                    <Col sm="2">
                                                        <Select placeholder="" value={this.state.unitTypeId} onChange={(value) => {
                                                            this.setState({
                                                                unitTypeId: value
                                                            }
                                                            )
                                                        }}
                                                        >
                                                            <Option key={null} value={null}>Select</Option>
                                                            {this.state.unitTypeSelectItems.map(i => (
                                                                <Option key={i.id} value={i.id}>{i.codeParentUnit.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Col>

                                                    <Col sm="2">
                                                        <AntButton type="primary" onClick={this.addDimension} icon={<PlusOutlined />}></AntButton>

                                                    </Col>

                                                </Form.Group>
                                            </FormAnt.Item>
                                        }

                                        {this.state.dimensionList.filter(p => p.active === true).map((d, i) => (
                                            <div style={{ backgroundColor: "white", marginTop: "1px" }}>
                                                {
                                                    <FormAnt.Item

                                                        name="OrganizationalLevelDesignation"
                                                        rules={[{ required: false, message: <FormattedMessage id="todo" defaultMessage="Please select status" /> }]} >

                                                        <Form.Group style={{ marginBottom: '1rem' }} as={Row} >

                                                            <Col sm="4">

                                                            </Col>
                                                            <Col sm="2">
                                                                <div>
                                                                    <Checkbox onChange={(e) => {
                                                                        var dimensionList = this.state.dimensionList;
                                                                        var obj = dimensionList[i];
                                                                        obj.select = e.target.checked;
                                                                        this.setState({
                                                                            dimensionList: dimensionList
                                                                        })
                                                                    }} checked={this.state.dimensionList[i].select}> </Checkbox>
                                                                </div>
                                                            </Col>

                                                            <Col sm="4">
                                                                <Form.Label style={{ color: '#0070C0', font: 'bold', fontSize: '11pt' }} >
                                                                    {d.description + ", " + d.abbreviation}
                                                                </Form.Label>
                                                            </Col>
                                                            <Col sm="2">
                                                                <Form.Label style={{ font: 'bold', fontSize: '11pt' }} >
                                                                    {Boolean(d.unitType) && Boolean(d.unitType.codeParentUnit) ? d.unitType.codeParentUnit.name : ''}
                                                                </Form.Label>
                                                            </Col>

                                                        </Form.Group>

                                                    </FormAnt.Item>}

                                            </div>))}



                                        <div hidden={this.state.hideSave}>
                                            {
                                                <Row>
                                                    <Col sm="3">
                                                    </Col>
                                                    <Col sm="5">
                                                        {/*<Button style={{ width: '100%' }} id='save-orgLevel' className="p-button-success" onClick={this.saveOrganizationalLevel} label="Save" />*/}
                                                        <ReactButton id="OrganizationalLevelSaveButton" type="submit" style={{ width: '100%', marginTop: '10px' }}
                                                            variant="success" ><FormattedMessage id="GeneralButtonSave" defaultMessage="Save" /></ReactButton>
                                                    </Col>
                                                    <Col sm="3">
                                                    </Col>
                                                </Row>
                                            }
                                        </div>



                                        <div hidden={this.state.hideUpdate}>
                                            {
                                                <Row>
                                                    <Col sm="3">
                                                    </Col>
                                                    <Col sm="2">
                                                        {/*<Button style={{ width: '100%' }} id='cancel-orgLevel' onClick={this.changeButtonCancel} className="p-button-danger" label="Cancel" />*/}
                                                        <ReactButton id="OrganizationalLevelCancelButton" style={{ width: '100%', marginTop: '10px' }} variant="secondary" onClick={this.cancel}>
                                                            <FormattedMessage id="GeneralButtonCancel" defaultMessage="Cancel" /></ReactButton>
                                                    </Col>
                                                    <Col sm="3">
                                                        {/*<Button style={{ width: '100%' }} id='update-orgLevel' onClick={this.updateDone} className="p-button-warning" label="Update" />*/}
                                                        <ReactButton id="OrganizationalLevelUpdateButton" style={{ width: '100%', marginTop: '10px' }} variant="warning" type="submit">
                                                            <FormattedMessage id="GeneralButtonUpdate" defaultMessage="Update" /></ReactButton>
                                                    </Col>
                                                    <Col sm="3">
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                        <Modal
                                            show={this.state.modalMessage}
                                            onHide={this.showOrHideModalMessage}
                                            backdrop="static"
                                            aria-labelledby="contained-modal-title-vcenter"
                                            centered>

                                            <Modal.Header closeButton>
                                                <Modal.Title id="contained-modal-title-vcenter">
                                                    <Row >
                                                        <Col sm="12">
                                                            {this.state.messageTip == "Success" &&
                                                                <i className="fas fa-check fa-2x" style={{ color: '#00ff2a' }} />}

                                                            {this.state.messageTip == "Warning" &&
                                                                <i className="fas fa-exclamation-circle fa-2x" style={{ color: '#faca2a' }} />}

                                                            {this.state.messageTip == "Error" &&
                                                                <i className="fas fa-times fa-2x" style={{ color: '#ff0400' }} />}
                                                        </Col>
                                                    </Row>
                                                </Modal.Title>
                                            </Modal.Header>

                                            <Modal.Body>
                                                <Row >
                                                    <Col sm="12">
                                                        {this.state.message}
                                                    </Col>
                                                </Row>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <ReactButton variant="secondary" onClick={this.showOrHideModalMessage}><FormattedMessage id="GeneralTextClose" defaultMessage="Close" /></ReactButton>
                                            </Modal.Footer>
                                        </Modal>
                                    </FormAnt>
                                </div>

                                {this.state.itemList.length > 0 && <Table style={{ marginTop: '3rem' }} size={`small`} columns={this.state.columns} dataSource={this.state.itemList} bordered scroll={{ x: 800, scrollToFirstRowOnChange: true }} >

                                </Table>}

                            </Card>

                       </MenuProvider>
                        {!this.state.whatIsSetting && <Whatis  ></Whatis>


                        }
                    </div>
                ) : (
                    <div>
                        <Redirect to="/error/error-v6" />
                    </div>
                )
        ) : (
                <div></div>
            );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        i18n: state.i18n
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemDimension) 